define("calendar/components/calendar/settings/bttp/error", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="u--text--bold" data-test-id="bttp-error">
    {{svg-jar "warning" class="o--icon o--icon--warning u--m__r__xs"}}
    {{#if @isLegacyBttp}}
      {{t "bttp.errors.not_enough_posts"}}
    {{else}}
      {{t "bttp.errors.unable_to_generate"}}
    {{/if}}
  </p>
  <p>
    {{html-safe @bttpReport.reportErrorText}}
  </p>
  
  {{#if @isLegacyBttp}}
    <p class="u--m__b__0">
      {{html-safe (t "bttp.num_of_posts" num=@bttpReport.numOfPosts nickname=@singleSocialProfile.displayNickname)}}
    </p>
    <div class="u--m__b__xs u--text--sm u--text--light">
      <span>{{@bttpInclusionDateText}}</span>
      <span class="u--float--right">
        {{t "bttp.required_posts" num=@bttpReport.requiredBttpPostData}}
      </span>
    </div>
  {{/if}}
  
  <div class="o--progress">
    <div class="o--progress__line" style={{@postPercentageCSS}}></div>
  </div>
  
  {{#unless @isOnLegacyPlan}}
    <Calendar::Settings::Bttp::InfoCard/>
  {{/unless}}
  
  */
  {
    "id": "+R5eLJfh",
    "block": "[[[10,2],[14,0,\"u--text--bold\"],[14,\"data-test-id\",\"bttp-error\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"warning\"],[[\"class\"],[\"o--icon o--icon--warning u--m__r__xs\"]]]],[1,\"\\n\"],[41,[30,1],[[[1,\"    \"],[1,[28,[35,2],[\"bttp.errors.not_enough_posts\"],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,2],[\"bttp.errors.unable_to_generate\"],null]],[1,\"\\n\"]],[]]],[13],[1,\"\\n\"],[10,2],[12],[1,\"\\n  \"],[1,[28,[35,3],[[30,2,[\"reportErrorText\"]]],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,1],[[[1,\"  \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n    \"],[1,[28,[35,3],[[28,[37,2],[\"bttp.num_of_posts\"],[[\"num\",\"nickname\"],[[30,2,[\"numOfPosts\"]],[30,3,[\"displayNickname\"]]]]]],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--m__b__xs u--text--sm u--text--light\"],[12],[1,\"\\n    \"],[10,1],[12],[1,[30,4]],[13],[1,\"\\n    \"],[10,1],[14,0,\"u--float--right\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"bttp.required_posts\"],[[\"num\"],[[30,2,[\"requiredBttpPostData\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,0],[14,0,\"o--progress\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--progress__line\"],[15,5,[30,5]],[12],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[51,[30,6]],[[[1,\"  \"],[8,[39,5],null,null,null],[1,\"\\n\"]],[]],null]],[\"@isLegacyBttp\",\"@bttpReport\",\"@singleSocialProfile\",\"@bttpInclusionDateText\",\"@postPercentageCSS\",\"@isOnLegacyPlan\"],false,[\"svg-jar\",\"if\",\"t\",\"html-safe\",\"unless\",\"calendar/settings/bttp/info-card\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp/error.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});